<template>
  <!-- Items Menu -->
  <div class="cabinet-console-menu-item" @click="itemClicked()">
      <div class="item-selection-indicator-active" :class="{
        'item-selected': itemIsSelected
      }">
          <img class="icon" :src="'/assets/images/' + icon" alt="" v-if="icon != null && icon.length > 0 && !itemIsSelected">
        
          <span v-if="region === 'uk'">
            <img class="icon iconBlue" :src="'/assets/images/' + iconBlue" alt="" v-if="iconBlue != null && iconBlue.length > 0 && itemIsSelected">
          </span>

          <span v-else-if="region === 'forex'">
            <img class="icon iconBlack" :src="'/assets/images/' + iconBlack" alt="" v-if="iconBlack != null && iconBlack.length > 0 && itemIsSelected">
          </span>

          <span v-else-if="region === 'mena'">
            <img class="icon iconBlack" :src="'/assets/images/' + iconBlack" alt="" v-if="iconBlack != null && iconBlack.length > 0 && itemIsSelected">
          </span>

          <span v-else>
            <img class="icon iconPink" :src="'/assets/images/' + iconPink" alt="" v-if="iconPink != null && iconPink.length > 0 && itemIsSelected">
          </span>
          <!-- <img class="icon iconPink" :src="'/assets/images/' + iconDisabled" alt="" v-if="iconDisabled != null && iconDisabled.length > 0 && optionDisabled"> -->
          <div class="row">
              <div class="label" :class="{'item-collapsed': itemIsCollapsed, 'is-submenu': itemIsASubmenu, 'label-selected': itemIsSelected}">
                {{ label }}
              </div>
              <div class="children-indicator"
                  :class="{'show-children-indicator': showChildrenIndicator && !itemIsCollapsed, 'opened-indicator': showChildren, 'item-collapsed': itemIsCollapsed}">
              </div>
          </div>
      </div>
  </div>
</template>

<script>
/* eslint-disable */

import store from "@/store"
import { onMounted, ref } from "@vue/runtime-core";
export default {
  name: "ConsoleMenuItem",
  props: [
    'idx',
    'icon',
    'label',
    'selected',
    'collapsed',
    'showChildren',
    'iconPink',
    'iconBlue',
    'iconBlack',
    'iconDisabled',
    'optionDisabled'
  ],
  computed: {
    itemIsASubmenu() {
      return !(this.icon != null && this.icon.length > 0);
    },
    itemIsCollapsed() {
      if (this.collapsed == null)
        return true;
      else
        return this.collapsed;
    },
    itemIsSelected() {
      if (this.selected == null)
        return true;
      else
        return this.selected;
    },
    showChildrenIndicator() {
      return (this.showChildren != null);
    }
  },
  methods: {
    itemClicked() {
      this.$emit('clicked', this.idx);
    }
  },
  emits: ['expand'],
  setup(props, { emit }) {
    let activeAccount = ref(false)
    const region = ref(process.env.VUE_APP_CABINET_ORIGIN)

    onMounted(() => {
      // setStyle()
    })

    const setStyle = () => {
      let userInfoStatus = localStorage.getItem("activeAccount")
      if (userInfoStatus === 'ACTIVE'){
        activeAccount.value = true
      }
    }

    return{
      activeAccount,
      setStyle,
      region,
    }
  }
}
</script>